import type { indicator, riskData } from '../types/interfaces';

/**
 * Obtiene los indicadores BPB del período anterior desde la respuesta de riesgos
 * (mismo origen que en RiskAnalysis: `risk_analysis.risks` → BPB).
 */
export function extractPreviousBpbIndicators(
  risks: unknown
): indicator[] | undefined {
  if (!Array.isArray(risks) || risks.length === 0) {
    return undefined;
  }
  const bpbRisk = risks.find(
    (r): r is riskData =>
      typeof r === 'object' &&
      r !== null &&
      'risk_code' in r &&
      (r as riskData).risk_code === 'BPB'
  );
  if (!bpbRisk) {
    return undefined;
  }
  const prev =
    bpbRisk.previous_bpb_indicators ??
    (bpbRisk as riskData & { previousBpbIndicators?: indicator[] })
      .previousBpbIndicators;
  if (Array.isArray(prev) && prev.length > 0) {
    return prev;
  }
  return undefined;
}
